// Portale cedolini esterno (Sistemi / Sportello.cloud)
export const PAYSLIP_PORTAL_URL =
  "https://profilo.sistemi.com/Account/Login?ReturnUrl=%2Fwsfed%2Fcallback%3Fwa%3Dwsignin1.0%26wtrealm%3Dhttps%253A%252F%252Fwww.sportello.cloud%252F%26wctx%3Drm%253D0%2526id%253Dpassive%2526ru%253D%25252f%25253f_menu%25253dSDCW";
